
import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer";
import { Box, Toolbar } from "@mui/material";

const PageLayout = ({ children }) => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Immediate scroll before paint
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    // Also scroll after render just in case
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header />
      <Toolbar sx={{ minHeight: { xs: 65, sm: 80 } }} />
      <Box sx={{ flex: 1 }}>{children}</Box>
      <Footer />
    </Box>
  );
};

export default PageLayout;
